<template>
    <div class="bs-modal-scroll-container bs-m-scroll">
        <slot></slot>
    </div>
</template>

<style lang="scss">
.bs-modal-scroll-container {
    overflow: hidden;
    overflow-y: auto;
    max-height: 85vh;
}
</style>